import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'followButtonAriaLabel', standalone: true })
export class FollowButtonAriaLabelPipe implements PipeTransform {
  public transform(isActive: boolean, favourite: boolean): string {
    if (favourite) {
      return isActive ? 'favourited' : 'set as favourite';
    } else {
      return null;
    }
  }
}
